import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-redistribution-status',
  templateUrl: './redistribution-status.component.html',
  styleUrls: ['./redistribution-status.component.scss'],
  standalone: true,
})
export class RedistributionStatusComponent {
  @Input() status!: string;
  
  public statusesMapping: { [key: string]: string} = {
    'ACTIVE': 'Актуально',
    'COMPLETE': 'Виконано',
    'PARTIALLY_COMPLETE': 'Частково виконано',
    'CANCELLED': 'Скасовано',
    'EXPIRED': 'Протерміновано',
  }
  
  public colorsMapping: { [key: string]: string} = {
    'ACTIVE': '#FFBD12',
    'COMPLETE': '#00C95C',
    'PARTIALLY_COMPLETE': '#00C95C',
    'CANCELLED': '#FC5C5C',
    'EXPIRED': '#FC5C5C',
  }

  // colors = {
  //   ACTIVE: '#FFBD12'
  // }
}
